import React from 'react';

import { Flex, Group, ScrollArea, Title } from '@mantine/core';

import { Item } from './Item';

interface Props {
    title: string;
    children: React.ReactNode;
}

export const List = ({ title, children }: Props) => {
    return (
        <Flex
            miw={480}
            bg="gray.1"
            right="gray.3"
            direction="column"
            h="100dvh"
            p={0}
            gap={0}
            style={(theme) => ({
                borderRight: `1px solid ${theme.colors.gray[3]}`,
            })}
        >
            <Flex
                justify="space-between"
                align="center"
                px={12}
                py={19}
                bg="gray.3"
                style={(theme) => ({
                    borderBottom: `1px solid ${theme.colors.gray[3]}`,
                    borderLeft: `4px solid ${theme.colors.gray[3]}`,
                })}
            >
                <Title order={2}>{title}</Title>
                <Group gap="xs">
                    {/* <Button variant="filled" compact leftSection={<IoAddSharp />}>New</Button> */}
                    {/* <TextInput icon={<IoSearchSharp />} placeholder="Search" /> */}
                    {/* <Tooltip label="Filter" position="bottom">
                        <ActionIcon variant="outline"><IoFilterSharp /></ActionIcon>
                    </Tooltip>
                    <Tooltip label="New project" position="bottom">
                        <ActionIcon variant="filled"><IoAddSharp /></ActionIcon>
                    </Tooltip> */}
                </Group>
            </Flex>
            <ScrollArea type="never">
                <Flex direction={'column'} p={0}>
                    {children}
                </Flex>
            </ScrollArea>
        </Flex>
    );
};

List.Item = Item;
